var _path, _path2, _path3, _path4, _path5, _path6, _circle;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDevice(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 32H4C2.89543 32 2 31.1046 2 30V12C2 10.8954 2.89543 10 4 10H29C30.1046 10 31 10.8954 31 12V18",
    stroke: "#8E18A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19 34V20C19 18.8954 19.8954 18 21 18H28",
    stroke: "#8E18A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 35V20C43 18.8954 42.1046 18 41 18H30",
    stroke: "#8E18A8",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8 35H27.7188V33H17.8V35ZM29.2573 36.5385H33.4883V34.5385H29.2573V36.5385ZM35.0268 35H45.2V33H35.0268V35ZM42.8 37H20.2V39H42.8V37ZM20.2 37C18.985 37 18 36.015 18 34.8H16C16 37.1196 17.8804 39 20.2 39V37ZM45 34.8C45 36.015 44.015 37 42.8 37V39C45.1196 39 47 37.1196 47 34.8H45ZM45.2 35C45.0895 35 45 34.9105 45 34.8H47C47 33.8059 46.1941 33 45.2 33V35ZM35.807 34.2198C35.807 34.6507 35.4577 35 35.0268 35V33C34.3531 33 33.807 33.5461 33.807 34.2198H35.807ZM33.4883 36.5385C34.7689 36.5385 35.807 35.5004 35.807 34.2198H33.807C33.807 34.3958 33.6643 34.5385 33.4883 34.5385V36.5385ZM26.9386 34.2198C26.9386 35.5004 27.9767 36.5385 29.2573 36.5385V34.5385C29.0813 34.5385 28.9386 34.3958 28.9386 34.2198H26.9386ZM27.7188 35C27.2879 35 26.9386 34.6507 26.9386 34.2198H28.9386C28.9386 33.5461 28.3925 33 27.7188 33V35ZM17.8 33C16.8059 33 16 33.8059 16 34.8H18C18 34.9105 17.9105 35 17.8 35V33Z",
    fill: "#8E18A8"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 38H12.4545M14.5 38H12.4545M13.5455 33L12.4545 38",
    stroke: "#8E18A8",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2 25C1.44772 25 1 25.4477 1 26C1 26.5523 1.44772 27 2 27V25ZM15 27C15.5523 27 16 26.5523 16 26C16 25.4477 15.5523 25 15 25V27ZM2 27H15V25H2V27Z",
    fill: "#8E18A8"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31,
    cy: 21,
    r: 1,
    fill: "#8E18A8"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevice);
export default __webpack_public_path__ + "static/media/device.155edc18.svg";
export { ForwardRef as ReactComponent };